<div *ngFor="let menu of parentMenu" class="menu-item">
    <div *ngIf="menu.id==0" class="avatar-container" style="padding: 12px;">
        <div class="row">
            <div class="col-4 d-flex justify-content-center">
                <img src="{{menu.image}}" alt="avatar" style="width: 38px;">
            </div>
            <div class="col-8">
                <div class="row">{{appService.Data.user_details.user_email}}</div>
                <div class="row" style="color: #495057; font-size: 12px;">
                    {{appService.Data.user_details.role_name}}
                    (<a (click)="signout()" style="cursor: pointer; text-decoration: none; color: #337ab7;">Logout</a>)
                </div>
            </div>
        </div>
    </div>
</div>
<span *ngIf="DparentMenu && DparentMenu.length > 0" style="font-weight: bold; padding-left: 16px; padding-top: 8px; display: block;">Daily Monitoring</span>
<div *ngFor="let menu of DparentMenu" class="menu-item">
   <a *ngIf="menu.routerLink && !menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.href && !menu.subMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        [attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
        <mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
    </a>

    <div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-sidenav-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-sidenav-menu>
    </div>
</div>
<span *ngIf="SparentMenu && SparentMenu.length>0" style="font-weight: bold; padding-left: 16px; padding-top: 8px; display: block;">Sell More</span>
<div *ngFor="let menu of SparentMenu" class="menu-item">
    <a *ngIf="menu.routerLink && !menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.href && !menu.subMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        [attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
        <mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
    </a>

    <div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-sidenav-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-sidenav-menu>
    </div>
</div>
<span *ngIf="MparentMenu && MparentMenu.length>0" style="font-weight: bold; padding-left: 16px; padding-top: 8px; display: block;">Manage your business</span>
<div *ngFor="let menu of MparentMenu" class="menu-item">

     <a *ngIf="menu.routerLink && !menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.href && !menu.subMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        [attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
        <mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
    </a>

    <div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-sidenav-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-sidenav-menu>
    </div>
</div>
<div *ngFor="let menu of parentMenu" class="menu-item">

    <a *ngIf="menu.routerLink && !menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.href && !menu.subMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
        [attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
    </a>
    <a *ngIf="menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu)"
        [id]="'menu-item-'+menu.id">
        <img src="{{menu.image}}" class="image_style">&nbsp;&nbsp;<span class="menu-title">{{menu.title}}</span>
        <mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
    </a>

    <div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-sidenav-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-sidenav-menu>
    </div>
</div>